import React, { Fragment, useRef, useState } from "react";

const CwdComponent = (props) => {
  const { customerWiseData, cwdSearchValue, setCwdSearchValue, searchValues } = props;
  const headers = ["customer_id", "rfid", "datetime_ist", "search_key", "status", "cs_log", "log_key"];
  const [cwdCurrentMatchIndex, setCwdCurrentMatchIndex] = useState(-1);
  const cwdCellRefs = useRef([]);

  const beautifyText = (text) => {
    return text.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
  };

  let cwdFilteredData = customerWiseData?.filter((row) =>
    headers.every((key) =>
      row[key] !== null ? row[key]?.toString().toLowerCase().includes(searchValues[key]?.toLowerCase() || "") : 'null'
    )
  );

  const onCwdSearchValueChange = (e) => {
    setCwdSearchValue(e.target.value);
  };

  const onCwdSearchKeyDown = (e) => {
    if (e.key === "Enter" && cwdSearchValue.trim() !== "") {
      const matches = [];
      const searchValue = cwdSearchValue.toLowerCase();

      // Highlight all matches
      cwdFilteredData.forEach((row, rowIndex) => {
        headers.forEach((key, colIndex) => {
          const cellValue = row[key]?.toString() || "";

          // Find matches and wrap in span
          const targetCell = cwdCellRefs.current[`${rowIndex}-${colIndex}`];
          if (targetCell) {
            const highlightedHtml = cellValue.replace(
              new RegExp(searchValue, "gi"),
              (match) => `<span class="bg-warning">${match}</span>`
            );
            targetCell.innerHTML = highlightedHtml; // Update cell with highlighted text

            // Track all matches for navigation
            const cellMatches = [...targetCell.querySelectorAll("span.bg-warning")];
            cellMatches.forEach((match) => matches.push(match));
          }
        });
      });

      if (matches.length > 0) {
        // Navigate to the next match
        const newIndex = (cwdCurrentMatchIndex + 1) % matches.length;
        setCwdCurrentMatchIndex(newIndex);

        matches.forEach((match, index) => {
          match.classList.toggle("bg-danger", index === newIndex);
        });

        const currentMatch = matches[newIndex];
        currentMatch.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
    }
  };

  return (
    <Fragment>
      <div
        className="border border-success border-1 rounded-2 border-opacity-25 p-2"
        style={{ height: "440px", overflow: "hidden", backgroundColor: "#ecf2ea" }}
      >
        <div className="d-flex">
          <div className="w-100">
            <h6 className="text-success text-center">CUSTOMER WISE DATA</h6>
          </div>
          <div className="flex-shrink-1 p-1">
            <input
              id="cwdSearchValue"
              placeholder={`Search`}
              onChange={onCwdSearchValueChange}
              onKeyDown={onCwdSearchKeyDown}
              value={cwdSearchValue}
              className="s-round-input"
              type="text"
              style={{
                padding: "10px 50px 10px 15px",
                height: "30px",
                width: "140px",
                fontSize: "12px",
              }}
            />
          </div>
        </div>
        <div
          className="table-responsive custom-scrollbar border"
          style={{ height: "90%", overflowY: "auto" }}
        >
          <table className="table align-top table-sm table-borderless">
            <thead className="table-light" style={{ position: "sticky", top: "0" }}>
              <tr>
                {headers.map((key) => (
                  <th key={key} scope="col" style={{ minWidth: "100px" }}>
                    {beautifyText(key)}
                  </th>
                ))}
              </tr>
              <tr>
                {headers.map((key) => (
                  <th key={key}>
                    <input
                      type="text"
                      className="form-control form-control-sm font-size-12"
                      placeholder={`Search ${key}`}
                      onChange={(e) => props.handleSearchChange(e, key)}
                      value={searchValues[key] || ""}
                    />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {cwdFilteredData?.length > 0 ? (
                cwdFilteredData.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {headers.map((key, colIndex) => (
                      <td
                        key={key}
                        className="border"
                        ref={(el) => (cwdCellRefs.current[`${rowIndex}-${colIndex}`] = el)}
                        style={{
                          maxWidth: '350px',
                          whiteSpace: 'normal',
                          wordWrap: 'break-word',
                          // wordBreak: 'break-word'
                        }}
                      >
                        {row[key] || '- -'}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={headers.length} className="text-center">
                    No matching records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Fragment>
  );
};

export default CwdComponent;
